module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/WVj9k/Images/cover.jpg?1685327319874",
      "alt": "This image is the cover for the book Jurassic Heart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jurassic Heart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When paleontologist Nick Eisenberg learns that someone thinks they have found velociraptor bones in Alberta, his curiosity overrides his desire to stay in London. After all, he’s one of the world’s leading experts on prehistoric predators and has always wanted to look for the velociraptor’s North American cousins. There’s only one problem: eco-conservationist Hunter Joseph. While Nick supervises the dig, Hunter rallies support from the locals to oppose the way the team is destroying the landscape in their search for dinosaur bones.")]), _vm._v(" "), _c('p', [_vm._v("Nick and Hunter just cannot get along. Hunter is self-righteous and pouty. Nick is narrow-minded and geeky. But they have to figure out how to work on the same site without killing each other, especially since someone else out there seems determined to cause Nick more problems than he could have ever imagined.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anna Martin\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0